import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import CustomDropdownFilter from 'src/components/custom-cells/CustomDropdownFilter';
import { TRANSMISSION_TYPE_STATUS_FILTER_OPTIONS } from '../utils/transmissionTypeStatusFilter';

export const TransmissionTypeStatusFilterMenu = (props: GridColumnMenuProps) => {
  const options = useMemo(
    () =>
      TRANSMISSION_TYPE_STATUS_FILTER_OPTIONS.map((label) => ({
        text: label,
        operator: label,
      })),
    []
  );

  return <CustomDropdownFilter {...props} option={options} filterOperator="contains" />;
};

export default TransmissionTypeStatusFilterMenu;
